export default __webpack_public_path__ + "static/media/Solana (SOL).50d484bf.svg";